"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Er en del av",
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData = []
    }) {
      let description;

      if (formData.length) {
        description = formData.length + " tema";
      } else {
        description = "Ingen tema";
      }

      return {
        "description": description
      };
    }

  },
  "ui:options": {
    "draggable": true,
    "collapsible": true
  },
  "ui:buttons": [{
    "type": "sidebar",
    "icon": "search",
    "label": "Finn tema"
  }, {
    "label": "Legg til"
  }]
};
exports.default = _default;
module.exports = exports.default;